export default function EmailConfirmado() {
  function volverAPlataforma() {
    // Marca este navegador como "ya tiene cuenta confirmada" para que en
    // Login.jsx le vuelva a aparecer la opcion de "Ingresar como
    // Estudiante" (antes de confirmar el correo, esa opcion se oculta).
    try { window.localStorage.setItem('espanolgo_email_confirmado', '1') } catch (err) {}
    window.location.href = '/'
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(145deg, #0a1628 0%, #0f2347 40%, #1a1248 70%, #0d1f3c 100%)',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: 420,
        width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1B3A8C', marginBottom: 10 }}>
          Bienvenido a EduNova - EspañolGo
        </h1>
        <p style={{ fontSize: 15, color: '#6B7280', marginBottom: 32, lineHeight: 1.6 }}>
          Tu correo ya quedó confirmado — gracias por darle la bienvenida al español en tu vida.<br /><br />
          Cada lección, cada palabra nueva, te acerca un poco más a hablarlo con confianza. Elige tu plan y da hoy el primer paso.
        </p>
        <button
          onClick={volverAPlataforma}
          style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #1B3A8C, #2D5BE3)',
            color: '#fff',
            border: 'none',
            borderRadius: 12,
            padding: '14px 32px',
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
            width: '100%'
          }}>
          Elegir mi plan →
        </button>
      </div>
    </div>
  )
}
